<nz-card [nzTitle]="'ADMIN.NOTIFICATIONS.DETAIL' | translate" [nzExtra]="backAction">
  <ng-template #backAction>
    <button nz-button (click)="back()">{{ 'ADMIN.NOTIFICATIONS.BACK' | translate }}</button>
  </ng-template>
  <nz-spin [nzSpinning]="loading">
    <nz-empty *ngIf="error" [nzNotFoundContent]="'ADMIN.NOTIFICATIONS.ERROR_LOAD' | translate"></nz-empty>
    <ng-container *ngIf="item">
      <nz-descriptions nzBordered [nzColumn]="2">
        <nz-descriptions-item [nzTitle]="'ADMIN.NOTIFICATIONS.SENT_AT' | translate">{{ item.sentAt | date:'short' }}
        </nz-descriptions-item>
        <nz-descriptions-item [nzTitle]="'ADMIN.NOTIFICATIONS.STATUS' | translate">
          <nz-tag>{{ ('ADMIN.NOTIFICATIONS.STATUS_' + item.status.toUpperCase()) | translate }}</nz-tag>
        </nz-descriptions-item>
        <nz-descriptions-item
          [nzTitle]="'ADMIN.NOTIFICATIONS.SEVERITY' | translate">{{ ('ADMIN.NOTIFICATIONS.SEVERITY_' + item.severity.toUpperCase()) | translate }}
        </nz-descriptions-item>
        <nz-descriptions-item
          [nzTitle]="'ADMIN.NOTIFICATIONS.TARGET' | translate">{{ item.target?.kind || ('ADMIN.NOTIFICATIONS.TARGET_NONE' | translate) }}
        </nz-descriptions-item>
        <nz-descriptions-item [nzTitle]="'ADMIN.NOTIFICATIONS.RECIPIENT_COUNT' | translate">{{ item.recipientCount }}
        </nz-descriptions-item>
        <nz-descriptions-item
          [nzTitle]="'ADMIN.NOTIFICATIONS.DELIVERY' | translate">{{ item.createdCount }} {{ 'ADMIN.NOTIFICATIONS.CREATED_COUNT' | translate }}
          · {{ item.failedCount }} {{ 'ADMIN.NOTIFICATIONS.FAILED_COUNT' | translate }}
        </nz-descriptions-item>
      </nz-descriptions>
      <section><h3>{{ 'ADMIN.NOTIFICATIONS.EN_CONTENT' | translate }}</h3><strong>{{ item.content.title.en }}</strong>
        <p>{{ item.content.body.en }}</p></section>
      <section><h3>{{ 'ADMIN.NOTIFICATIONS.DE_CONTENT' | translate }}</h3><strong>{{ item.content.title.de }}</strong>
        <p>{{ item.content.body.de }}</p></section>
      <section *ngIf="item.recipientIds?.length"><h3>{{ 'ADMIN.NOTIFICATIONS.RECIPIENTS' | translate }}</h3>
        <div class="recipients">
          <nz-tag *ngFor="let user of item.recipientIds">{{ recipientLabel(user) }}</nz-tag>
        </div>
      </section>
      <section *ngIf="!item.recipientIds?.length && item.recipientMode === 'all_eligible'"><h3>{{ 'ADMIN.NOTIFICATIONS.RECIPIENTS' | translate }}</h3>
        <p>{{ 'ADMIN.NOTIFICATIONS.ALL_ELIGIBLE_USERS' | translate }}</p>
        <p *ngIf="item.excludedRecipientCount">{{ 'ADMIN.NOTIFICATIONS.EXCLUDED_COUNT' | translate:{count: item.excludedRecipientCount} }}</p>
        <p>{{ 'ADMIN.NOTIFICATIONS.RECIPIENT_COUNT' | translate }}: {{ item.recipientCount }}</p>
      </section>
    </ng-container>
  </nz-spin>
</nz-card>
